import Step1 from './step-1-view';

export default Step1;
